<template>
  <main>
    <section class="p-404">
      <div class="p-404_container">
        <div class="p-404_body">
          <div class="p-404_content">
            <h2 class="p-404_content_title">404 error</h2>
            <p class="p-404_content_content">お探しのページが見つかりませんでした。</p>
            <div class="p-404_content_group">
              <router-link :to="ROUTER_PATH.MY_PAGES" class="p-404_content_group_page-curr">マイページ</router-link>
              <router-link :to="ROUTER_PATH.HOME" class="p-404_content_group_homepage">トップページ</router-link>
            </div>
            <p class="p-404_content_des">{{ countdownMessage }}</p>
          </div>
          <div class="p-404_img"><img :src="not_found_404" alt="" class="Not Found" /></div>
        </div>
      </div>
      <!-- <div class="p-404_breakcrumb">
                <router-link :to="ROUTER_PATH.HOME"  href="#">タイムシェアリング</router-link>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#0582C1" class="w-4 h-4">
                    <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
                <span>404error</span>                  
            </div> -->
    </section>
  </main>
</template>

<script setup>
import { useRouter } from "vue-router";
import { ref, onMounted, computed } from "vue";
import { ROUTER_PATH } from "@/client/const";
import not_found_404 from "@/client/assets/images/404.png";
const router = useRouter();
const interval = ref(10);
const referrer = location.pathname;
const countdownMessage = computed(() => {
  return `${interval.value}秒後にトップページへ自動で移動します`;
});
onMounted(() => {
    
  const robotsTag = document.querySelector('meta[name="robots"]');
  if (robotsTag) {
      robotsTag.setAttribute("content", "noindex");
  }
  
  const countdownInterval = setInterval(() => {
    interval.value--;
    if (interval.value === 0) {
      clearInterval(countdownInterval);
      if (robotsTag) {
        robotsTag.setAttribute("content", "");
      }
      redirect();
    }
  }, 1000);
});
function redirect() {
  if (location.pathname === referrer) {
    router.push("/");
  }
}
</script>
<style scoped lang="scss">
@import "./NotFound.scss";
</style>
